// extracted by mini-css-extract-plugin
export default {"FootBar":"cart_FootBar__abKet","Buttons":"cart_Buttons__LsYGW","Summary":"cart_Summary__lOVQL","wrapper":"cart_wrapper__9EUF8"};